const CREATE_TENANT_USER = 'CREATE_TENANT_USER';
const CREATE_TENANT_USER_SUCCESS = 'CREATE_TENANT_USER_SUCCESS';
const CREATE_TENANT_USER_ERROR = 'CREATE_TENANT_USER_ERROR';
const UPDATE_TENANT_USER = 'UPDATE_TENANT_USER';
const UPDATE_TENANT_USER_SUCCESS = 'UPDATE_TENANT_USER_SUCCESS';
const UPDATE_TENANT_USER_ERROR = 'UPDATE_TENANT_USER_ERROR';
const FETCH_TENANT_USER = 'FETCH_TENANT_USER';
const FETCH_TENANT_USER_SUCCESS = 'FETCH_TENANT_USER_SUCCESS';
const FETCH_TENANT_USER_ERROR = 'FETCH_TENANT_USER_ERROR';
const TENANT_USER_DETAILS_IS_EDIT = 'TENANT_USER_DETAILS_IS_EDIT';
const ADD_TENANT_USER_IN_MANAGER = 'ADD_TENANT_USER_IN_MANAGER';
const FETCH_TENANT_USERS_UTIL_DATA = 'FETCH_TENANT_USERS_UTIL_DATA';
const FETCH_TENANT_USERS_UTIL_DATA_SUCCESS = 'FETCH_TENANT_USERS_UTIL_DATA_SUCCESS';
const FETCH_ALL_TENANT_USERS = 'FETCH_ALL_TENANT_USERS';
const FETCH_ALL_TENANT_USERS_SUCCESS = 'FETCH_ALL_TENANT_USERS_SUCCESS';
const FETCH_ALL_TENANT_USERS_ERROR = 'FETCH_ALL_TENANT_USERS_ERROR';
const DELETE_TENANT_USER = 'DELETE_TENANT_USER';
const DELETE_TENANT_USER_SUCCESS = 'DELETE_TENANT_USER_SUCCESS';
const DELETE_TENANT_USER_ERROR = 'DELETE_TENANT_USER_ERROR';
const TENANT_USER_DETAIL_CLEANUP_FUNC = 'TENANT_USER_DETAIL_CLEANUP_FUNC';
const UPDATE_TENANT_USER_SETTINGS = 'UPDATE_TENANT_USER_SETTINGS';
const UPDATE_TENANT_USER_SETTINGS_SUCCESS = 'UPDATE_TENANT_USER_SETTINGS_SUCCESS';
const UPDATE_TENANT_USER_SETTINGS_ERROR = 'UPDATE_TENANT_USER_SETTINGS_ERROR';
const SEND_DETAILS_TO_TENANT_USER = 'SEND_DETAILS_TO_TENANT_USER';
const SEND_DETAILS_TO_TENANT_USER_SUCCESS = 'SEND_DETAILS_TO_TENANT_USER_SUCCESS';
const SEND_DETAILS_TO_TENANT_USER_ERROR = 'SEND_DETAILS_TO_TENANT_USER_ERROR';
const UPDATE_TENANT_USER_PERMISSIONS = 'UPDATE_TENANT_USER_PERMISSIONS';
const UPDATE_TENANT_USER_PERMISSIONS_SUCCESS = 'UPDATE_TENANT_USER_PERMISSIONS_SUCCESS';
const UPDATE_TENANT_USER_PERMISSIONS_ERROR = 'UPDATE_TENANT_USER_PERMISSIONS_ERROR';
const SET_TENANT_USER_PERMISSIONS_IS_EDIT = 'SET_TENANT_USER_PERMISSIONS_IS_EDIT';
const SET_TENANT_USERS_MANAGER_STATE = 'SET_TENANT_USERS_MANAGER_STATE';

export {
  CREATE_TENANT_USER,
  CREATE_TENANT_USER_SUCCESS,
  CREATE_TENANT_USER_ERROR,
  UPDATE_TENANT_USER,
  UPDATE_TENANT_USER_SUCCESS,
  UPDATE_TENANT_USER_ERROR,
  UPDATE_TENANT_USER_SETTINGS,
  UPDATE_TENANT_USER_SETTINGS_SUCCESS,
  UPDATE_TENANT_USER_SETTINGS_ERROR,
  FETCH_TENANT_USER,
  FETCH_TENANT_USER_SUCCESS,
  FETCH_TENANT_USER_ERROR,
  ADD_TENANT_USER_IN_MANAGER,
  TENANT_USER_DETAILS_IS_EDIT,
  FETCH_TENANT_USERS_UTIL_DATA,
  FETCH_TENANT_USERS_UTIL_DATA_SUCCESS,
  FETCH_ALL_TENANT_USERS,
  FETCH_ALL_TENANT_USERS_SUCCESS,
  FETCH_ALL_TENANT_USERS_ERROR,
  DELETE_TENANT_USER,
  DELETE_TENANT_USER_SUCCESS,
  DELETE_TENANT_USER_ERROR,
  TENANT_USER_DETAIL_CLEANUP_FUNC,
  SEND_DETAILS_TO_TENANT_USER,
  SEND_DETAILS_TO_TENANT_USER_SUCCESS,
  SEND_DETAILS_TO_TENANT_USER_ERROR,
  UPDATE_TENANT_USER_PERMISSIONS,
  UPDATE_TENANT_USER_PERMISSIONS_SUCCESS,
  UPDATE_TENANT_USER_PERMISSIONS_ERROR,
  SET_TENANT_USER_PERMISSIONS_IS_EDIT,
  SET_TENANT_USERS_MANAGER_STATE,
};
